export const DISPLAY_MODAL = "displaymodal";
export const HIDE_MODAL = "hidemodal";
